<!-- @format -->

<div [class.courseunit-substitution-group]="substitution.length > 1" class="prior-learning-expandable">
  @for (courseUnitSubstitution of substitution; track courseUnitSubstitution) {
    @if (openCourseUnitModalEvent.observers.length > 0) {
      <sis-course-unit-box
        [courseUnitGroupId]="courseUnitSubstitution.courseUnitGroupId"
        [categoryCssClass]="'cu-color-' + (colorIndex + 1)"
        (codeClickAction)="openCourseUnitModalEvent.emit($event)">
        @if (courseUnitSubstitution.credits) {
          <div course-unit-box="notifications" class="cu-notification-bar">
            <div class="cu-notification">
              <span class="cu-notification-header">
                <sis-icon icon="info"></sis-icon>
              </span>
              <span
                class="cu-notification-content"
                translate="STUDIES.SUBSTITUTION_EDITOR.SUBSTITUTED_CREDITS"
                [translateParams]="{ credits: courseUnitSubstitution.credits }">
              </span>
            </div>
          </div>
        }
      </sis-course-unit-box>
    } @else {
      <sis-course-unit-box
        [courseUnitGroupId]="courseUnitSubstitution.courseUnitGroupId"
        [categoryCssClass]="'cu-color-' + (colorIndex + 1)">
        @if (courseUnitSubstitution.credits) {
          <div course-unit-box="notifications" class="cu-notification-bar">
            <div class="cu-notification">
              <span class="cu-notification-header">
                <sis-icon icon="info"></sis-icon>
              </span>
              <span
                class="cu-notification-content"
                translate="STUDIES.SUBSTITUTION_EDITOR.SUBSTITUTED_CREDITS"
                [translateParams]="{ credits: courseUnitSubstitution.credits }">
              </span>
            </div>
          </div>
        }
      </sis-course-unit-box>
    }
  }
</div>
